import React from "react";

export const formatTextWithLineBreaks = (text) => {
  return text.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < text.split("\n").length - 1 && <br />}
    </React.Fragment>
  ));
};

export function isEmpty(...args) {
  let isEmptyReturn = true;
  for (let index = 0; index < args.length; index++) {
    const item = args[index];
    if (Array.isArray(item)) {
      for (let itemIndex = 0; itemIndex < item.length; itemIndex++) {
        const item2 = item[itemIndex];
        isEmptyReturn = isEmptyReturn && !item2.getValue();
      }
    } else {
      isEmptyReturn = isEmptyReturn && !item;
    }
  }
  return isEmptyReturn;
}

export function getLangDcatVersion(conformsTo = []) {
  return (
    conformsTo?.find((v) => v.includes("lang-dcat-ap/"))?.split("/").pop() || ""
  );
}
